import { useEffect, useState } from "react";
import AlimModalMedium from "../ui-elements/AlimModalMedium";
import LazyOnVisible from "../LazyOnVisible";

const GlobalSearchContainer=()=>{
    const [isSearchModalVisible,setIsSearchModalVisible]=useState(false);

    useEffect(()=>{
        const handler = () => {
            setIsSearchModalVisible(prev=>!prev);
        }

        window.addEventListener('GLOBAL_SEARCH_EVENT', handler);
        return () => window.removeEventListener('GLOBAL_SEARCH_EVENT', handler);
    },[])

    return(
        <>
            {
                isSearchModalVisible?
                    <AlimModalMedium modalFunc={setIsSearchModalVisible} modalTitle={""} customStyles={"pt-16 py-12 px-0 max-h-full"} customWidth={"w-full md:w-[700px]"} customHeight={"h-full max-h-[700px]"}>
                        <div className="h-[61vh]">
                            <LazyOnVisible
                                componentKey="GlobalSearch"
                                fallback={"Please wait..."}
                            />
                        </div>
                    </AlimModalMedium>
                :
                    null
            }
        </>
    )
}

export default GlobalSearchContainer;